// extracted by mini-css-extract-plugin
export default {"container":"HideColumns_container__8EDlv","text":"HideColumns_text__3rCjV"};